module.exports = __webpack_public_path__ + "4b2aaa23aac76beb75c50227bfbb41fe.svg";